export const storeInsightsCopy = {
  titulo: (daLoja: string) => `Funil ${daLoja}`,
} as const;
